import React from 'react'

import {Participant} from '../types'

import {useMeleeContext} from '../../draft/context/MeleeContextProvider'


const PlayerScoreTable = () => {
    const meleeContext = useMeleeContext();
    if(!meleeContext && !meleeContext!.tournament){
        return(<h4>NO PLAYERS</h4>)
    }

    const players = meleeContext!.tournament.Players;
    const remainingGames = meleeContext!.tournament.GroupStageGames.filter((g) => g.Winners.length === 0);

    let sortedPlayers = players.sort((a,b) => b.StockDifference-a.StockDifference)
    .sort((a,b) => b.Wins-a.Wins)


    const GetPlacementColor = (placement:number) => {
        return '';
    }

    const GetPlayerRow = (player:Participant, placement:number) => {
        const losses = player.GamesPlayed-player.Wins;
        const isDone = remainingGames.filter((g) => g.Players.some((p) => p.Number === player.Number)).length === 0;
        const placementColor = isDone ? GetPlacementColor(placement) : '';
        return(
            <tr key={`player-row-${player.Number}`} className={`${placementColor}`}>
                <td>{placement}</td>
                <td>{player.Name}</td>
                <td>{player.Wins}</td>
                <td>{losses}</td>
                <td>{player.StockDifference}</td>
            </tr>
        )
    }

    return(
        <table className='melee-table'>
            <tr>
                <th>#</th>
                <th>Player</th>
                <th>Wins</th>
                <th>Losses</th>
                <th>Score</th>
            </tr>

            {
                sortedPlayers.map((p,i) => GetPlayerRow(p,i+1))
            }
        </table>
    )
}

export default PlayerScoreTable;